import { ActionContext, ActionTree, GetterTree } from "vuex";

const actions: ActionTree<any, any> = {
  add({ commit }: ActionContext<any, any>, payload: number[]): void {
    commit("add", payload);
  },
  setState({ commit }: ActionContext<any, any>, payload: any[]): void {
    commit("setState", payload);
  },
  remove({ commit }: ActionContext<any, any>, payload: number[]): void {
    commit("remove", payload);
  },
  clearState({ commit }: ActionContext<any, any>): void {
    commit("clearState");
  }
};

const mutations = {
  add(state: any, payload: { ids: number[], type: number }) {
    const ids = state.seibiDetailIds[payload.type].slice();
    if (payload.ids.length > 0) {
      payload.ids.forEach(id => {
        if (ids.indexOf(id) === -1) {
          ids.push(id);
        }
      });
    }
    const seibiDetailIds = state.seibiDetailIds;
    seibiDetailIds[payload.type] = ids;
    Object.assign(state, { seibiDetailIds });
  },
  setState(state: any, payload: any) {
    state.selectingSeibiDetailIds = payload;
  },
  remove(state: any, payload: { ids: number[], type: number }) {
    const ids = state.seibiDetailIds[payload.type].slice();
    if (payload.ids.length > 0) {
      payload.ids.forEach(id => {
        const indexRemove = ids.indexOf(id);
        if (indexRemove > -1) {
          ids.splice(indexRemove, 1);
        }
      });
    }
    const seibiDetailIds = state.seibiDetailIds;
    seibiDetailIds[payload.type] = ids;
    Object.assign(state, { seibiDetailIds });
  }
};

const getters: GetterTree<any, any> = {
  isExist: (state: any) => (id: number, type: number) => {
    const anotherType = type === 0 ? 1 : 0;
    return state.seibiDetailIds[anotherType].indexOf(id) > -1;
  },
  isSeibiDetailIdExist: (state: any) => (payload: any) => {
    const filteredState = state.selectingSeibiDetailIds.filter((e: any) => {
      return e.seibiDetailId == payload.seibiDetailId && e.sknUketsukeInspectId != payload.sknUketsukeInspectId;
    });
    return filteredState.length > 0;
  }
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: { seibiDetailIds: [[], []], selectingSeibiDetailIds: [] },
  getters,
  actions,
  mutations
};
